import type { NextPage } from 'next'
import {
  AppLayout,
  PageHeader,
  DisclosureContent,
  PartialContainer,
} from '@components'
import { NextSeo } from 'next-seo'

const Disclosure: NextPage = () => {
  return (
    <AppLayout>
      <PartialContainer>
        <NextSeo
          title="Disclosure"
          description="MarketX is a one-stop shop for over 300 family offices, funds, and
        high net worth individuals to access high growth investment
        opportunities."
          canonical="https://www.marketxventures.com/disclosure"
        />
        <PageHeader title="General MarketX Disclosures" />
        <div className="mb-32">
          <DisclosureContent />
        </div>
      </PartialContainer>
    </AppLayout>
  )
}

export default Disclosure
